var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-label"},[_c('span',[_vm._v(" "+_vm._s(_vm.data.name)+" ")]),_c('div',[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:(`Количество групп`),expression:"`Количество групп`",modifiers:{"hover":true,"top":true}}]},[_vm._v(_vm._s(_vm.data.groups.length))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }